import { formatDate, formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'conditionalFormat',
	standalone: false,
})
export class ConditionalFormatPipe implements PipeTransform {
	transform(value: any, type: string, format?: string, locale?: string): string {
		if (!format || !type) {
			return value;
		}

		if (!value) {
			return '-';
		}

		try {
			switch (type?.toLowerCase()) {
				case 'number':
					return formatNumber(value, locale || 'da-DK', format || '1.0-2');
				case 'date':
					return formatDate(value, format || 'shortDate', locale || 'da-DK');
				case 'time':
					return this.formatMilliseconds(value, format || 'hh:mm:ss');
				default:
					return value.toString();
			}
		} catch (exception) {
			console.log(`[ConditionalFormatPipe][transform] Exception: ${JSON.stringify(exception)}`);
			return value.toString();
		}
	}

	// Custom formatters

	formatMilliseconds(ms: number, format: string): string {
		const days = Math.floor(ms / 86_400_000);
		const leftoverMsAfterDays = ms % 86_400_000;
		const hours = Math.floor(leftoverMsAfterDays / 3_600_000);
		const leftoverMsAfterHours = leftoverMsAfterDays % 3_600_000;
		const minutes = Math.floor(leftoverMsAfterHours / 60_000);
		const leftoverMsAfterMinutes = leftoverMsAfterHours % 60_000;
		const seconds = Math.floor(leftoverMsAfterMinutes / 1_000);
		const milliseconds = leftoverMsAfterMinutes % 1_000;
		const pad = (num: number, size: number = 2) => String(num).padStart(size, '0');
		let result = format;
		result = result.replace(/(SSS|sss)/g, pad(milliseconds, 3));
		result = result.replace(/(DD|dd)/g, pad(days));
		result = result.replace(/(hh|HH)/g, pad(hours));
		result = result.replace(/(mm|MM)/g, pad(minutes));
		result = result.replace(/(ss|SS)/g, pad(seconds));
		return result;
	}
}
